// Formats a monetary number into a localized currency string
export function formatMoney(
  amount: number | string,
  currency: string = 'MAD',
  locale: string = 'en-US'
): string {
  const numeric = typeof amount === 'string' ? parseFloat(amount) : amount;
  if (isNaN(numeric)) return '0.00';

  try {
    return new Intl.NumberFormat(locale, {
      style: 'currency',
      currency: currency.toUpperCase()
    }).format(numeric);
  } catch {
    return `${numeric.toFixed(2)} ${currency.toUpperCase()}`;
  }
}

/** Two decimals, as a dirham amount is always written. */
const TWO_PLACES = { minimumFractionDigits: 2, maximumFractionDigits: 2 } as const;

/** One number formatter per language, made once: toLocaleString built a new one per call, and a home page formats hundreds of prices. */
const MAD_NUMBERS = {
  'ar-MA': new Intl.NumberFormat('ar-MA', TWO_PLACES),
  'fr-MA': new Intl.NumberFormat('fr-FR', TWO_PLACES),
  'en-US': new Intl.NumberFormat('en-US', TWO_PLACES)
} as const;

// Formats amount specifically for Moroccan Dirhams (MAD)
export function formatMAD(
  amount: number | string,
  locale: 'ar-MA' | 'fr-MA' | 'en-US' = 'fr-MA'
): string {
  const numeric = typeof amount === 'string' ? parseFloat(amount) : amount;
  if (isNaN(numeric)) return '0.00 DH';

  if (locale === 'ar-MA') return `${MAD_NUMBERS['ar-MA'].format(numeric)} د.م.`;
  if (locale === 'fr-MA') return `${MAD_NUMBERS['fr-MA'].format(numeric)} DH`;
  return `${MAD_NUMBERS['en-US'].format(numeric)} MAD`;
}
